module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1132.4a16ee4d.png";